import React from 'react'

import { Div } from 'elements/layout/Div'
import { P } from 'elements/text/P'

import type { TCommunity } from 'modules/community/types'
import { UserAvatar } from 'modules/user/components/UserAvatar'
import { UserName } from 'modules/user/components/UserName'
import { UserProfileLink } from 'modules/user/components/UserProfileLink'

export type TUserInfoSectionProps = {
  community: TCommunity
}

export const UserInfoSection: TFC<TUserInfoSectionProps> = ({ community }) => (
  <Div p="10px 20px" align="center">
    <UserProfileLink userId={community.user} w="100%">
      <UserAvatar size="small" userId={community.user} />
      <P bold>trans:community:community.animated-by.short</P>
      <UserName userId={community.user} bold />
    </UserProfileLink>
  </Div>
)
